<template>
	<div>
        <div class="flex justify-between mb-5 border-b border-gray-300 pb-2">
            <div class="flex items-center justify-between w-full">
                <h1 class="module-header">Units</h1>
            </div>
        </div>
        <div class="grid gap-x-16" :class="fromReatlas ? 'grid-cols-1' : 'grid-cols-2'">
            <div class="w-full">
                <table v-if="buildings.selectedBuilding.units.length" class="w-full">
                    <thead class="cursor-pointer">
                        <tr>
                            <th class="text-center">Floor</th>
                            <th class="text-center">Suite</th>
                            <th class="text-right">Size</th>
                            <th class="text-right">Status</th>
                            <th class="text-right">Ask Price</th>
                            <th class="text-right">Last Update</th>
                            <th v-if="showEditActions"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="unit in sortedUnits" :key="unit.id" :class="{ 'highlighted': highlightedUnit && unit.id == highlightedUnit.id }">
                            <td class="text-center">{{ unit.floor }}</td>
                            <td class="text-center">{{ unit.suite }}</td>
                            <td class="text-right">{{ unit.size | number }}</td>
                            <td class="text-right">{{ unit.status }}</td>
                            <td :data-precision="2" :data-originalvalue="unit.rent_cost" class="is-currency text-right">{{ formatCurrency(unit.rent_cost, 2) }}</td>
                            <td class="text-right">{{ unit.updated_at | date }}</td>
                            <td v-if="showEditActions" class="text-right">
                                <div class="flex justify-end space-x-3">
                                    <button @click="showEditUnit(unit.id)" type="button">
                                       <inline-svg name="edit-pencil" classes="w-5 h-5 cursor-pointer"></inline-svg>
                                    </button>
                                    <button @click="confirmDeleteUnit(unit.id)" type="button" class="ml-3">
                                        <inline-svg name="trash"></inline-svg>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="mt-8 flex flex-col items-center justify-center space-y-2">
                    <span class="text-xl">No Units Found</span>
                    <button
                        type="button"
                        @click.prevent="showCreateUnit"
                        class="flex items-center btn btn-small btn-indigo">
                            <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                            <span class="ml-2">New Unit</span>
                    </button>
                </div>

                <button v-if="buildings.selectedBuilding.units.length" @click.prevent="showCreateUnit" class="mt-3 self-end flex items-center btn btn-small btn-indigo">
                    <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                    <span class="ml-2">New Unit</span>
                </button>
            </div>
            <div :class="fromReatlas ? 'mt-10 w-full' : ''">
                <stack-chart
                    :data="buildings.selectedBuilding.stack"
                    @unitSelected="highlightUnit"
                    @unitdeSelected="highlightedUnit = {}">
                </stack-chart>
            </div>
        </div>

        <modal name="manage-units" width="50%" height="auto" draggable=".modal-header">
            <manage-units></manage-units>
        </modal>

        <notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: 'ReoptUnits',

    	props: {
            showEditActions: {
                type: Boolean,
                default: false
            },

            fromReatlas: {
                type: Boolean,
                default: false
            }
        },

    	data() {
    		return {
                highlightedUnit: {},
    		}
    	},

        computed: {
            ...mapState(['buildings']),
            ...mapState(['units']),
            ...mapState(['expenses']),
            ...mapGetters(['selectedUnit']),

            sortedUnits() {
                return _.sortBy(this.buildings.selectedBuilding.units, [(unit) => parseInt(unit.floor)]);
            }
        },

        methods: {
            highlightUnit(e) {
                this.highlightedUnit = _.find(this.units.all, (unit) => {
                    return unit.floor == e.categoryLabel && unit.size == e.dataValue;
                });
            },

            showCreateUnit(unitId) {
                this.units.all.push({
                    id: 'new',
                    building_id: this.buildings.selectedBuilding.id,
                    expenses: {},
                    status: null,
                    is_renewal_space: null,
                    size: null,
                    divisible: null,
                    floor: null,
                    suite: null,
                    ti_allowance: null,
                    comment: null
                });

                this.units.selectedUnitId = 'new';

                this.$modal.show('manage-units');
            },

            showEditUnit(unitId) {
                this.units.selectedUnitId = unitId;

                this.$modal.show('manage-units');
            },

            showManageUnits() {
                this.units.selectedUnitId = null;

                this.$modal.show('manage-units');
            },

            removeUnit(unitId) {
                var unit = _.find(this.units.all, ['id', unitId]);

                if (! unit) {
                    return;
                }

                var stackSize = this.buildings.selectedBuilding.stack[unit.floor][unit.status];

                // remove the unit
                this.buildings.selectedBuilding.units = _.remove(this.buildings.selectedBuilding.units, (unit) => { return unit.id != unitId });
                this.units.all = _.remove(this.units.all, (unit) => { return unit.id != unitId });

                // update the stack chart
                this.buildings.selectedBuilding.stack[unit.floor][unit.status] = stackSize - unit.size;
            },

            confirmDeleteUnit(unitId) {
                this.$swal({
                    title: 'Delete this unit?',
                    text: "ALL data will be lost, including any lease information attached to this unit",
                    type: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'Yes - Delete it',
                    confirmButtonClass: 'btn btn-red',
                    showCancelButton: true,
                    cancelButtonClass: 'btn btn-secondary mr-4',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.deleteUnit(unitId);
                    }
                });
            },

            deleteUnit(unitId) {
                if (unitId == 'new') {
                    this.removeUnit(unitId);

                    return;
                }

                axios.delete('/units/' + unitId).then(response => {
                    this.removeUnit(unitId);

                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: response.data.message
                    });
                }).catch(error => {
                    console.log(error);
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: error.response.data.message
                    });
                });
            },
        }
    }
</script>
